const Devices = {
    DESKTOP:'DESKTOP',
    MOBILE:'MOBILE'
}

export default Devices;